import React from 'react';

import {

  useNodesState,
  useEdgesState,
  Node,
  Edge,
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';
import { Shield } from 'lucide-react';
import ProjectCaseStudy from '../components/ProjectCaseStudy';

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'Start User Input' },
    position: { x: 50, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '2',
    data: { label: 'User Submits Form' },
    position: { x: 250, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '3',
    data: { label: 'Zapier Webhook Trigger' },
    position: { x: 500, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '4',
    data: { label: 'Data Gets as JSON' },
    position: { x: 750, y: 100 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '5',
    data: { label: 'OpenAI Receives Data' },
    position: { x: 150, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '6',
    data: { label: 'Improve User Message' },
    position: { x: 400, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '7',
    data: { label: 'Format Data for Sheets' },
    position: { x: 650, y: 300 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '8',
    data: { label: 'Update Google Sheets' },
    position: { x: 300, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
  {
    id: '9',
    data: { label: 'End Process' },
    position: { x: 500, y: 500 },
    style: {
      background: '#18181b',
      color: 'white',
      border: '1px solid #7c3aed',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: 'bold',
      padding: '10px',
    },
  },
];

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true },
  { id: 'e4-5', source: '4', target: '5', animated: true },
  { id: 'e5-6', source: '5', target: '6', animated: true },
  { id: 'e6-7', source: '6', target: '7', animated: true },
  { id: 'e7-8', source: '7', target: '8', animated: true },
  { id: 'e8-9', source: '8', target: '9', animated: true },
];

const ProjectTwo = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, , onEdgesChange] = useEdgesState(initialEdges);

  return (
    <ProjectCaseStudy
      title="Google Sheets Automation Flow"
      tagline="Unstructured input in — clean, structured rows out, automatically."
      icon={<Shield className="w-7 h-7" />}
      context="Operational data was arriving as messy, unstructured text (emails, forms, messages) and someone had to retype it into spreadsheets by hand."
      built="An AI pipeline that parses unstructured input through the OpenAI API, maps it to the right schema, and writes clean rows into Google Sheets — no manual entry, no copy-paste errors."
      stack={['OpenAI API', 'Google Sheets API', 'Automation', 'Data parsing']}
      highlights={['Zero manual data entry', 'Structured, queryable output', 'Fewer transcription errors']}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
    />
  );
};

export default ProjectTwo;